import { Payment } from "./components/Payment";


const AppRoutes = [
  {
    index: true,
    element: <Payment />
  },
  {
    path: '/Payment',
    element: <Payment /> 
  }
];

export default AppRoutes;
